import React from 'react';
import { Alert } from 'reactstrap';

export default class RejectedFilesAlert extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.files.length > 0 && nextProps.files.length !== this.props.files.length) {
      this.setState({ visible: true });
    }
  }

  onDismiss = () => {
    this.setState({ visible: false });
  }

  render() {
    return (<Alert
      className="uploader-alert"
      color="warning"
      isOpen={this.state.visible}
      toggle={this.onDismiss}
    >
      <strong>Warning!</strong> The following files cannot be uploaded:
      <ul className="list-group">
        {this.props.files.map((file, index) =>
          (<li key={index} className="uploader-alert-item">
            {file.name}
          </li>),
        )}
      </ul>
    </Alert>);
  }
}
